(() => {
  if (window.bringnersCampaignExpiry) return;
  const refresh = () => {
    document.querySelectorAll('[data-campaign-section]').forEach(section => {
      const grid = section.querySelector('[data-campaign-grid]');
      grid.querySelectorAll('[data-expires-at]').forEach(card => {
        const expiry = Date.parse(card.dataset.expiresAt);
        if (!Number.isFinite(expiry) || expiry <= Date.now()) card.remove();
      });
      const notice = section.querySelector('[data-campaign-notice]');
      notice.hidden = !grid.querySelector('[data-campaign-id]');
      const templates = section.querySelector('[data-campaign-fallbacks]').content;
      for (const card of templates.children) {
        if (grid.children.length >= 3) break;
        if (![...grid.children].some(existing => existing.dataset.fallbackId === card.dataset.fallbackId)) {
          grid.append(card.cloneNode(true));
        }
      }
    });
  };
  window.bringnersCampaignExpiry = { refresh };
  refresh();
  setInterval(refresh, 30000);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
